/* -------------------------------------------------------------------------------------
Vuex module to manage area data

Main components
---------------
Fetches area tracks. This is a new table containing area information and coordinates for its boundary

mutations:
- SET_AREAS: set the areas array in vuex state

actions:
- fetchAreas: get the areas from the API and update corresponding arrays in vuex store

getter:
- none

---------------------------------------------------------------------------------------*/

// import tourdb library
import ApiService from '@/services/ApiService.js'
import { returnUniqueAreas } from '@/services/CommonFunctions.js'

export const namespaced = true

export const state = {
  areas: []
}

export const mutations = {
  
  // set the areas array in vuex state
  SET_AREAS(state, areas) {
    state.areas = areas
  }
}

export const actions = {

  // STANDARD STORE ACTIONS
  // ----------------------

  // Gets all areas from the API and pushes them to the store
  fetchAreas({ commit, dispatch }) {
    
    ApiService.getAreas()
      .then(response => {
        commit('SET_AREAS', response.data.areas)
      })

      // Error handling
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was an error getting the areas: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  }
}

export const getters = {

  // return regions array
  regions: state => {
    let areas = JSON.parse(JSON.stringify(state.areas))
    return areas.filter(region => region.subtypeCode === 'region')
  },

  // return cantons array
  cantons: state => {
    let areas = JSON.parse(JSON.stringify(state.areas))
    return returnUniqueAreas(areas, 'canton')
  },
  
  // return countries array
  countries: state => {
    let areas = JSON.parse(JSON.stringify(state.areas))
    return returnUniqueAreas(areas, 'country')
  },

}
